module.exports = __webpack_public_path__ + "static/media/surfing_1600.db57ae3d.jpg";